<template>
  <div class="h-full d-flex align-center justify-center">
    <div v-if="carregando_dados" class="position-absolute text-center z-1">
      <v-progress-circular color="red" indeterminate size="40" width="3" />
      <p class="ma-0 font-14 mt-2 text-gray-900">Carregando... aguarde</p>
    </div>


    <div class="w-full h-full">
      <apexchart
        height="100%"
        type="bar"
        :options="options"
        :series="series"
      />
    </div>
  </div>
</template>

<script>
import {opcoes} from "./Opcoes";
import {movimentacoesCategoria} from "@/api/compras/MateriaPrima";
import {categoria_selecionada} from "@/components/compra/materiaPrima/compra/Helpers/CategoriaSelecionado";

const SERIE_PADRAO = [0,0,0,0,0,0,0,0,0,0,0,0,0];

export default {
  mixins: [categoria_selecionada],
  props: {
    count_atualizar_detalhes_categoria: Number,
  },
  data: () => ({
    options: opcoes,
    series: [],
    maxValorChart: 0,
    analiseProduto: {},
    analiseDefault: {
      entradas: SERIE_PADRAO,
      saidas: SERIE_PADRAO,
      referencias: SERIE_PADRAO
    },
    carregando_dados: true
  }),
  computed: {
    grupo_compra() {
      return this.$store.getters['usuario/getGrupoCompras'];
    },
    maxEscala() {
      return parseInt(this.maxValorChart + this.maxValorChart / 4) || 1;
    },
    yaxis: function () {
      return {
        labels: {
          formatter: (n) => {
            return this.formatter(n || 1);
          },
          style: {
            color: "#000",
            cssClass: "apexcharts-yaxis-title",
          },
        },
        forceNiceScale: true,
        min: 0,
        max: this.maxEscala,
      };
    },
  },
  mounted() {
    this.analiseProduto = this.analiseDefault;
    this.render();
    this.buscarDadosDeMovimentacaoDoEstoque();
  },
  watch: {
    categoria_selecionada() {
      this.buscarDadosDeMovimentacaoDoEstoque();
    },
    count_atualizar_detalhes_categoria() {
      this.buscarDadosDeMovimentacaoDoEstoque()
    }
  },
  methods: {
    buscarDadosDeMovimentacaoDoEstoque() {
      this.carregando_dados = true;

      this.atualizarSeries(this.analiseDefault.entradas, this.analiseDefault.saidas)

      const parametros = {
        id_grupo: this.grupo_compra,
        id_categoria: this.categoria_selecionada.idcategoria
      }

      movimentacoesCategoria(parametros)
        .then(movimentacoes => {
          this.analiseProduto = movimentacoes;
          this.render();
          this.carregando_dados = false;
        });
    },
    getMovimentacoes(){
      return Object.assign({}, this.analiseProduto);
    },
    render () {
      const { entradas, saidas, referencias } = this.analiseProduto;

      const arrayTotal = entradas.concat(saidas);

      this.maxValorChart = arrayTotal.reduce(function (a, b) {
        return Math.max(a, b);
      }, 1);

      this.options = {
        yaxis: this.yaxis,
        labels: referencias
      };

      this.atualizarSeries(entradas, saidas)
    },
    atualizarSeries(entradas, saidas) {
      this.series = [
        {
          name: "Entradas",
          color: "#043554",
          type: "column",
          data: entradas,
        },
        {
          name: "Saídas",
          color: "#D60E2B",
          type: "column",
          data: saidas,
        }
      ];
    },
    formatter: function (n) {
      const ranges = [
        { divider: 1e15, suffix: "P" },
        { divider: 1e12, suffix: "T" },
        { divider: 1e9, suffix: "G" },
        { divider: 1e6, suffix: "M" },
        { divider: 1e3, suffix: "k" }
      ];

      for (let i = 0; i < ranges.length; i++) {
        if (n >= ranges[i].divider) {
          return ((Math.round(n) / ranges[i].divider).toFixed(2).toString() +ranges[i].suffix);
        }
      }

      const r = new Intl.NumberFormat("pt-BR", {style: "decimal", maxDigits: 2}).format(n);

      return r == 0 ? "" : r;
    },
  },
};
</script>
